import React from 'react';
import Slider from 'react-slick';
import './BrandPromoSection.css';

// Sample images
import hair from '../components/assets/images/pro-1.jpg';
import skin from '../components/assets/images/pro-10.jpg';
import men from '../components/assets/images/pro-11.jpg';
import women from '../components/assets/images/pro-12.jpg';
import memory from '../components/assets/images/pro-13.jpg';
import beauty from '../components/assets/images/pro-2.jpg';
import brain from '../components/assets/images/pro-5.jpg';
import eye from '../components/assets/images/pro-4.jpg';

const categories = [
  { img: hair, label: '' },
  { img: skin, label: '' },
  { img: men, label: "" },
  { img: women, label: "" },
  { img: memory, label: '' },
  { img: beauty, label: '' },
  { img: brain, label: '' },
  { img: eye, label: '' },
];

const CategorySlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 2,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <div className="category-slider">
      <Slider {...settings}>
        {categories.map((item, index) => (
          <div className="category-card" key={index}>
            <img src={item.img} alt={item.label} />
            <p>{item.label}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CategorySlider;
